import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type Language = 'es' | 'en';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly STORAGE_KEY = 'lang';
  readonly available: { code: Language; label: string; flag: string }[] = [
    { code: 'es', label: 'Español', flag: '🇵🇦' },
    { code: 'en', label: 'English', flag: '🇺🇸' },
  ];

  readonly currentLang = signal<Language>('es');

  constructor(private translate: TranslateService) {}

  init(): void {
    const saved = localStorage.getItem(this.STORAGE_KEY) as Language | null;

    let lang: Language;
    if (saved && (saved === 'es' || saved === 'en')) {
      lang = saved;
    } else {
      // const browserLang = navigator.language?.split('-')[0];
      // lang = browserLang === 'en' ? 'en' : 'es';
      lang = 'es'
      localStorage.setItem(this.STORAGE_KEY, lang);
    }

    this.translate.addLangs(['es', 'en']);
    this.translate.setDefaultLang('es');
    this.translate.use(lang);
    this.currentLang.set(lang);
  }

  use(lang: Language): void {
    this.translate.use(lang);
    localStorage.setItem(this.STORAGE_KEY, lang);
    this.currentLang.set(lang);
  }

  current(): Language {
    return this.currentLang();
  }
}
